// RESPONSIVE NAVS
// ----------------------------------------------------------------------------
// $(function () {
//     var pull = $('.pull');
//     var menu = $('.nav ul');
//     var nav = $('.nav');

//     $(pull).on('click', function(e) {
//         e.preventDefault();
//         $('body').toggleClass('is--nav-slide-open');
//         if (nav.hasClass('slide-down')) {
//             menu.slideToggle();
//         }

//     });
//     $(window).resize(function () {
//         var w = $(window).width();
//         if (w > 320 && menu.is(':hidden')) {
//             menu.removeAttr('style');
//         }
//     });
//     $('.nav-slide_mask').on('click touch', function () {
//         $('body').toggleClass('is--nav-slide-open');
//     });
// });


//RESPONSIVE NAVS (DEPRECATED UNIFICACIÓ DE HEADERS)
//----------------------------------------------------------------------------
$(function () {
    $('body').on('click touch', '[data-navslide="open"]', function(e){
        $('body').addClass('is--nav-slide-open');
        e.preventDefault();
    });

    $('body').on('click touch', '[data-navslide="close"]', function(e){
        $('body').removeClass('is--nav-slide-open');
        e.preventDefault();
    });

    $(document).on('click touch', '[data-navslide="toggle"]', function(e){
        $('body').toggleClass('is--nav-slide-open');
        e.preventDefault();
    });
});


// Header compartit amb drive2
// ----------------------------------------------------------------------------
$(function () {
    $(document).on('click touch', '[data-topbar="trigger"]', function(e){
        $('body').toggleClass('is--mt-Overlay-visible has--no-scroll');
        $('#mt-Topbar').toggleClass('is-open');
        e.preventDefault();
        if (!$('.mt-Overlay').length > 0) {
          var $overlay = $('<div class="mt-Overlay"></div>');
          $('body').append($overlay);
        }
    });
    $(document).on('click touch', '.mt-Overlay', function(e){
        $('body').toggleClass('is--mt-Overlay-visible');
        $('#mt-Topbar').toggleClass('is-open');
    });
});
